import { ref, Ref, watch, reactive } from "vue";

import login from "@/../CsdPublic/login";
import { getStorage, setStorage } from "@/utils/storage";

import useStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import _ from "lodash";
import { openImgVerify, closeImgVerify } from "./verify";
import { isMobile } from "@/data/pubilc";
import Links from "@/config/link";
import { wxLoginUrl } from "@/config/apiDomain";
import { useStoreTime } from "./useVerifyTime";
// import { openBindPhoneDialog } from "../personal/userBind";
import { isAppWebView, isMiniWechatWebView } from "@/utils/app/common";
import useJump from "@/utils/app/useJump";
import { ElMessage } from "element-plus";
import { CallbackID } from "@/MessageHandler";

const mobileDevice =
  navigator.userAgent.match(/Mobi/i) ||
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/iPhone/i);
const showLoginDialog: Ref<boolean> = ref(false);
const loginCodeUrl: Ref<string> = ref("");
const validCode: Ref<boolean> = ref(true);
const verifyTime: Ref<number> = ref(0);
const voiceTime: Ref<number> = ref(0);
const smsType: Ref<"login" | "bind"> = ref<"login" | "bind">("login");

const {
  setTime: setVerifyTime,
  // getTime: getVerifyTime,
  isFrozen: isVerifyFrozen,
  storageTimer: storageVerifyTimer,
  removeTime: removeVerifyTime,
} = useStoreTime("verifyCodeEndTime");

const {
  setTime: setVoiceTime,
  // getTime: getVoiceTime,
  isFrozen: isVoiceFrozen,
  storageTimer: storageVoiceTimer,
  removeTime: removeVoiceTime,
} = useStoreTime("VoiceCodeEndTime");

const isVoiceCode = ref(false);
const loginWay = reactive([
  {
    name: "扫码登录",
    type: 0,
    isShow: true,
  },
  {
    name: "手机号登录",
    type: 1,
    isShow: true,
  },
]);
const loginWayType: Ref<number> = ref(0);
const inviteId: Ref<number | null> = ref(null);

watch(
  isMobile,
  (val) => {
    if (val) {
      loginWayType.value = 1;
      loginWay.length = 1;
      loginWay[0] = { name: "手机号登录", type: 1, isShow: true };
    }
  },
  { immediate: true }
);

//解析url
const getOrigin = () => {
  const url = new URL(window.location.href);
  const urlSplitJoin = url.origin + "/home/#/brank";
  return (
    urlSplitJoin +
    `${
      window.location.href.includes("from=invite") ||
      window.location.href.includes("share_href=1")
        ? "?from=invite"
        : ""
    }`
  );
};

const openLoginDialog = _.throttle(
  () => {
    (window as any).mbQuery(CallbackID.WEB_LOSS, "", null);

    // if (isMiniWechatWebView() || isAppWebView()) {
    //   ElMessage.warning("请先登录");
    //   useJump("switchTab", { url: "/pages/mine/index?needLogin=true" });
    //   return;
    // }
    // getOrigin();
    // const bool = login.isWeiXinEnv();
    // if (bool) {
    //   login.loginWeiXin(getOrigin(), wxLoginUrl);
    // } else {
    // showLoginDialog.value = true;
    // getLoginCode();
    // }
  },
  3000,
  { leading: true, trailing: false }
);

const closeLoginDialog = () => {
  showLoginDialog.value = false;
  stopLoginPoll();
  loginCodeUrl.value = "";
  loginWayType.value = 0;
};

const getLoginCode = async () => {
  if (isMobile.value || loginWayType.value === 1) return;
  try {
    // 获取登录二维码
    const res = await login.getLoginCode();
    loginCodeUrl.value = res.codeUrl;
    validCode.value = true;
    // 登录的轮询
    const poll = await login.loginPoll();
    setStorage("token", poll.token);
    ElMessage.success("登录成功");
    closeLoginDialog();
    const publicStore = useStore();
    const { isLogin } = storeToRefs(publicStore);
    isLogin.value = true;
    judgeInvite();
  } catch (e: any) {
    console.log(e);
    const { msg } = e;
    if (msg) {
      ElMessage.error(msg);
    }
    if (e.code === 1000) validCode.value = false;
  }
};

const stopLoginPoll = () => {
  login.stopInterval();
};

// 手机号码验证
const phoneNumberVerify = (phone: number | string) => {
  if (phone == "") {
    ElMessage.warning("请输入手机号码");
    return false;
  }
  const reg = /^(?:(?:\+|00)86)?1[0-9]{10}$/;
  if (!reg.test(phone.toString())) {
    ElMessage.warning("手机号码格式不正确");
    return false;
  }
  return true;
};

// 计算还剩多少时间可以重新获取
// const calcVerifyTime = () => {
//   if (getStorage("verifyCodeEndTime")) {
//     let verifyCodeEndTime = getStorage("verifyCodeEndTime");
//     let nowTime = new Date().getTime();
//     if ((verifyCodeEndTime as any) - nowTime > 0) {
//       return Math.floor(((verifyCodeEndTime as any) - nowTime) / 1000);
//     }
//   }
//   return 0;
// };
// 每秒计算一次重新获取的时间
// const verifyCodeTimer = () => {
//   let timer = setInterval(() => {
//     verifyTime.value = calcVerifyTime();
//     if (verifyTime.value === 0) {
//       clearInterval(timer);
//     }
//   }, 1000);
// };

const getVerifyResult = (phoneNumber: string) => {
  // 手机号验证
  if (!phoneNumberVerify(phoneNumber)) {
    return false;
  }
  if (isVoiceCode.value) {
    if (isVoiceFrozen()) {
      return false;
    }
    return true;
  }
  if (isVerifyFrozen()) {
    return false;
  }
  return true;
};

// 获取验证码
const getVerifyCode = async (
  phoneNumber: string,
  type: "login" | "bind",
  isVoice = false
) => {
  if (verifyTime.value > 0) return;
  isVoiceCode.value = isVoice;
  smsType.value = type;
  getUnVerifyCode(phoneNumber);
  return;
  if (!getVerifyResult(phoneNumber)) return;
  if (mobileDevice) getUnVerifyCode(phoneNumber);
  else openImgVerify();
};
// 获取验证码(不需要图形验证)
const getUnVerifyCode = async (phoneNumber: string) => {
  try {
    await login.getPhoneVerifyCode(phoneNumber, {
      smsType: smsType.value,
      // message_type: isVoiceCode.value ? "vms" : undefined,
      message_type: undefined,
    });
    if (isVoiceCode.value) {
      setVoiceTime();
      voiceTime.value = 59;
      storageVoiceTimer((time: number) => {
        voiceTime.value = time;
      });
    } else {
      setVerifyTime();
      verifyTime.value = 59;
      storageVerifyTimer((time: number) => {
        verifyTime.value = time;
      });
    }
  } catch (e: any) {
    // 弹出错误信息
    ElMessage.error(e.msg);
    // removeStorage("verifyCodeEndTime");
    removeVerifyTime();
    removeVoiceTime();
    verifyTime.value = 0;
    voiceTime.value = 0;
  }
};
const getVerifyCodeAgain = async (phoneNumber: string, params: any) => {
  try {
    await login.getPhoneVerifyCode(phoneNumber, {
      ...params,
      smsType: smsType.value,
      // message_type: isVoiceCode.value ? "vms" : undefined,
      message_type: undefined,
    });
    if (isVoiceCode.value) {
      setVoiceTime();
      voiceTime.value = 59;
      storageVoiceTimer((time: number) => {
        voiceTime.value = time;
      });
    } else {
      setVerifyTime();
      verifyTime.value = 59;
      storageVerifyTimer((time: number) => {
        verifyTime.value = time;
      });
    }

    ElMessage.success("验证码已发送，若未收到请联系客服");
    closeImgVerify();
  } catch (e: any) {
    // 弹出错误信息
    ElMessage.error(e.msg);
    removeVerifyTime();
    removeVoiceTime();
    voiceTime.value = 0;
    // removeStorage("verifyCodeEndTime");
    verifyTime.value = 0;
  }
};

const phoneLogin = async (form: any) => {
  if (!phoneNumberVerify(form.phoneNumber)) return;
  if (!form.code) {
    ElMessage.warning("请输入验证码");
    return;
  }
  try {
    const data = await login.phoneLogin(form.phoneNumber, {
      code: form.code,
    });
    setStorage("token", data.token);
    ElMessage.success("登录成功");
    closeLoginDialog();
    const publicStore = useStore();
    const { isLogin } = storeToRefs(publicStore);
    isLogin.value = true;
    judgeInvite();
  } catch (e: any) {
    ElMessage.error(e.msg);
  }
};

const openPrivacy = () => {
  window.open(Links.privacy, "_blank");
};
const openAgreement = () => {
  window.open(Links.agreement, "_blank");
};

const judgeInvite = async () => {
  const publicStore = useStore();
  const { changeUserInfo, changeVipInfo } = publicStore;
  const { isVip, userInfo } = storeToRefs(publicStore);
  try {
    await Promise.all([changeUserInfo(), changeVipInfo()]);
    if (
      !userInfo.value.bind_phone &&
      !inviteId.value &&
      !isVip.value &&
      getStorage("invite_id")
    ) {
      // openBindPhoneDialog("phone", {
      //   isInvite: true,
      // });
    }
  } catch {
    //
  }
};

const overdueToken = () => {
  login.logOut();
  ElMessage.warning("请先登录");
  (window as any).mbQuery(CallbackID.WEB_LOSS, "", null);
};

export {
  loginWay,
  loginWayType,
  mobileDevice,
  phoneNumberVerify,
  showLoginDialog,
  loginCodeUrl,
  validCode,
  verifyTime,
  voiceTime,
  openLoginDialog,
  closeLoginDialog,
  getLoginCode,
  stopLoginPoll,
  getVerifyCode,
  phoneLogin,
  getVerifyCodeAgain,
  openPrivacy,
  openAgreement,
  judgeInvite,
  overdueToken,
};
